/**
 * Reading Room motion vocabulary — named springs and timing constants the
 * variant's surfaces share.
 *
 * Two reasons for naming these:
 *  1. Consistency across the variant — every card entrance feels like it
 *     belongs to the same product.
 *  2. A single place to tune the vocabulary when something feels off.
 *
 * The base easing curves and timing tokens come from `juice/`. This file
 * names the *combinations* the Reading Room favours. Other variants will
 * declare their own combinations in their own `motion.ts`.
 */

import { easing, timings } from '@/juice';

/** Card-settles-like-a-real-object spring. Used for hub tiles + question cards. */
export const cardSpring = {
  type: 'spring' as const,
  stiffness: 220,
  damping: 22,
  mass: 0.9,
};

/** Tighter spring used on hover lifts where we want a snappier landing. */
export const hoverSpring = {
  type: 'spring' as const,
  stiffness: 320,
  damping: 18,
};

/** Question-card-on-the-desk spring. Slightly more mass than `cardSpring`. */
export const questionSpring = {
  type: 'spring' as const,
  stiffness: 240,
  damping: 21,
  mass: 1,
};

/** Option-button stagger spring — calmer landing on the lower-tier elements. */
export const optionSpring = {
  type: 'spring' as const,
  stiffness: 300,
  damping: 26,
};

/** Stagger delay between consecutive option buttons (seconds). */
export const OPTION_STAGGER_S = 0.05;

/** Reveal-frame hold before Next becomes available (ms). The pause IS the juice. */
export const REVEAL_HOLD_MS = 400;

/** Pause between a reveal exiting upward and the Affirmation rising (ms). */
export const HANDOFF_PAUSE_MS = 150;

/** Re-export the toolbox tokens we lean on most, so consumers can just import here. */
export { easing, timings };
